import { Box, Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { getStatusStyles } from '../../clients.styles'
import { getStatusLabel } from '../../clients.constants'
import { styles } from './retention-badges.styles'

interface RetentionBadgesProps {
  membershipStatus?: string | null
  daysAbsent?: number | null
}

interface BadgeConfig {
  labelKey: string
  bgcolor: string
  color: string
}

export const DAYS_ABSENT_THRESHOLDS: {
  days: number
  labelKey: string
  bgcolor: string
  color: string
}[] = [
  {
    days: 60,
    labelKey: 'clients.retentionBadges.daysAbsent',
    bgcolor: 'error.lightest',
    color: 'error.dark',
  },
  {
    days: 30,
    labelKey: 'clients.retentionBadges.daysAbsent',
    bgcolor: 'orange.lightest',
    color: 'orange.dark',
  },
  {
    days: 14,
    labelKey: 'clients.retentionBadges.daysAbsent',
    bgcolor: 'warning.lightest',
    color: 'warning.dark',
  },
  {
    days: 7,
    labelKey: 'clients.retentionBadges.daysAbsent',
    bgcolor: 'yellow.lightest',
    color: 'yellow.dark',
  },
  {
    days: 0,
    labelKey: 'clients.retentionBadges.active',
    bgcolor: 'success.lightest',
    color: 'success.dark',
  },
]

export function getDaysAbsentBadge(daysAbsent: number | null | undefined): BadgeConfig | null {
  if (daysAbsent == null) return null
  return DAYS_ABSENT_THRESHOLDS.find((threshold) => daysAbsent >= threshold.days) ?? null
}

const RetentionBadges = ({ membershipStatus, daysAbsent }: RetentionBadgesProps) => {
  const { t } = useTranslation('core')

  const daysAbsentBadge = getDaysAbsentBadge(daysAbsent)
  const statusStyles = membershipStatus ? getStatusStyles(membershipStatus) : null
  const statusLabel = membershipStatus ? getStatusLabel(membershipStatus, t) : null
  const showStatus = statusStyles && statusLabel

  if (!showStatus && !daysAbsentBadge) return null

  return (
    <Box sx={styles.badgeRow}>
      {showStatus && (
        <Chip
          label={statusLabel}
          size="small"
          sx={styles.chip(statusStyles.bgcolor, statusStyles.color)}
        />
      )}
      {daysAbsentBadge && daysAbsent != null && (
        <Chip
          label={t(daysAbsentBadge.labelKey, { count: daysAbsent })}
          size="small"
          sx={styles.chip(daysAbsentBadge.bgcolor, daysAbsentBadge.color)}
        />
      )}
    </Box>
  )
}

export default RetentionBadges
